var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.lang
      ? _c("div", { staticClass: "agency-card", class: _vm.networkClass }, [
          _c("div", [
            _vm.agency.distance && _vm.maxDistance
              ? _c("div", { staticClass: "distance" }, [
                  _c("span", { class: _vm.networkClass }, [
                    _vm._v(_vm._s(_vm.lang.labels.distance))
                  ]),
                  _vm._v(" "),
                  _vm.maxDistance
                    ? _c(
                        "div",
                        [
                          _c("distance-bar", {
                            attrs: {
                              distance: _vm.agency.absolute_distance,
                              label: _vm.agency.distance,
                              "max-distance": _vm.maxDistance
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm._t("header"),
                _vm._v(" "),
                _c("div", { staticClass: "header-card-map" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "agency-data agency-heading align-items-center pt-0"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-8" }, [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("img", {
                              attrs: {
                                src:
                                  "/img/icons/icon-" +
                                  _vm.agency.network +
                                  ".svg",
                                alt: _vm.agency.network,
                                width: "38",
                                height: "35"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "agency-heading-data" }, [
                              _c("div", { staticClass: "business-name" }, [
                                _c("span", { staticClass: "affiliate-label" }, [
                                  _vm._v(
                                    _vm._s(_vm.trans("labels.affiliate")) + ":"
                                  )
                                ]),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.agency.name) +
                                    "\n                                        "
                                ),
                                _c("div", { staticClass: "affiliate-desc" }, [
                                  _vm._v(_vm._s(_vm.agency.address) + " ")
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.agency.aicat
                          ? _c("div", { staticClass: "col-4" }, [
                              _c("div", { staticClass: "agency-aicat" }, [
                                _c("img", {
                                  staticClass: "agency-aicat-img",
                                  attrs: { src: _vm.agency.aicat }
                                })
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.closeButton
                        ? _c(
                            "button",
                            {
                              staticClass: "close-menu",
                              on: { click: _vm.closeCard }
                            },
                            [
                              _c("masked-image", {
                                attrs: {
                                  src: "/img/icons/close.svg",
                                  height: "20",
                                  width: "20"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-xl-6 col-4 pr-0 agency-img-zone" },
                    [
                      _vm.agency.url_image
                        ? _c("img", {
                            attrs: { src: _vm.agency.url_image, width: "100%" }
                          })
                        : _c("img", {
                            attrs: { src: "/img/img-agency.svg", width: "100%" }
                          })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "agency-data col pl-0" }, [
                    _c("div", { staticClass: "map-card" }, [
                      _c(
                        "div",
                        { staticClass: "address d-flex align-items-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "p-2" },
                            [
                              _c("masked-image", {
                                staticClass: "ico_map",
                                attrs: { src: "/img/icons/map.svg" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.agency.address) + " ")])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-contact" }, [
                        _vm.agency.status == "ATTIVO" ||
                        _vm.agency.status == "PRE_SOSPESO"
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "d-flex align-items-center",
                                  attrs: { href: "mailto:" + _vm.agency.email }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: { src: "/img/icons/email.svg" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "email" }, [
                                    _vm._v(_vm._s(_vm.agency.email))
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.whatsapp
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/ico_whatsapp.svg"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "whatsapp" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://wa.me/" +
                                            this.agency.whatsapp,
                                          target: "_blank"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.track("wa")
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.agency.whatsapp))]
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.phone
                          ? _c("div", { staticClass: "phone-map" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        staticStyle: { width: "1rem" },
                                        attrs: {
                                          src: "/img/icons/phone-agency.svg",
                                          alt: _vm.agency.phone
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "phone" }, [
                                    _vm._v(_vm._s(_vm.agency.phone))
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.url_facebook
                          ? _c("div", { staticClass: "fb-map" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/ico_facebook.svg"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm.agency.url_facebook
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.agency.url_facebook,
                                              target: "_blank",
                                              rel: "noopener"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.lang.labels.facebook
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.url_instagram
                          ? _c("div", { staticClass: "fb-map" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/ico_instagram.svg"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm.agency.url_instagram
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.agency.url_instagram,
                                              target: "_blank",
                                              rel: "noopener"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.lang.labels.instagram
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.url_linkedin
                          ? _c("div", { staticClass: "fb-map" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/ico_linkedin.svg"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm.agency.url_linkedin
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.agency.url_linkedin,
                                              target: "_blank",
                                              rel: "noopener"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.lang.labels.linkedin
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.url_twitter
                          ? _c("div", { staticClass: "fb-map" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/ico_twitter.svg"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm.agency.url_twitter
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.agency.url_twitter,
                                              target: "_blank",
                                              rel: "noopener"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.lang.labels.twitter
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "agency-actions col-lg-3" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-contact email",
                          attrs: {
                            href: "mailto:" + _vm.agency.email,
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [
                          _c("masked-image", {
                            attrs: { src: "/img/icons/email.svg" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.agency.email))])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "phone-detail" },
                        [
                          _vm.phoneToShow
                            ? _vm._t("phone", function() {
                                return [
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.showPhone,
                                          expression: "! showPhone"
                                        }
                                      ],
                                      staticClass: "btn btn-network",
                                      class:
                                        "btn-network-" + _vm.agency.network,
                                      on: {
                                        click: function($event) {
                                          return _vm.track("phone")
                                        }
                                      }
                                    },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/phone-agency.svg",
                                          alt: _vm.agency.phone
                                        }
                                      }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.lang.labels.telephone) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showPhone,
                                          expression: "showPhone"
                                        }
                                      ],
                                      staticClass: "btn btn-network",
                                      attrs: { href: "tel:" + _vm.agency.phone }
                                    },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/phone-agency.svg",
                                          alt: _vm.agency.phone
                                        }
                                      }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.phoneToShow) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              })
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isActive
                        ? [
                            _vm._t("links", function() {
                              return [
                                _vm.agency
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "links-container" },
                                        [
                                          _vm.agency.url_facebook
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-contact facebook",
                                                  attrs: {
                                                    href:
                                                      _vm.agency.url_facebook,
                                                    target: "_blank",
                                                    rel: "noopener"
                                                  }
                                                },
                                                [
                                                  _c("masked-image", {
                                                    attrs: {
                                                      src:
                                                        "/img/icons/ico_facebook.svg"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lang.labels.facebook
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.agency.url_instagram
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-contact instagram",
                                                  attrs: {
                                                    href:
                                                      _vm.agency.url_instagram,
                                                    target: "_blank",
                                                    rel: "noopener"
                                                  }
                                                },
                                                [
                                                  _c("masked-image", {
                                                    attrs: {
                                                      src:
                                                        "/img/icons/instagram-big.svg"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lang.labels
                                                          .instagram
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.agency.url_linkedin
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-contact linkedin",
                                                  attrs: {
                                                    href:
                                                      _vm.agency.url_linkedin,
                                                    target: "_blank",
                                                    rel: "noopener"
                                                  }
                                                },
                                                [
                                                  _c("masked-image", {
                                                    attrs: {
                                                      src:
                                                        "/img/icons/linkedin-big.svg"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lang.labels.linkedin
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.agency.url_twitter
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-contact twitter",
                                                  attrs: {
                                                    href:
                                                      _vm.agency.url_twitter,
                                                    target: "_blank",
                                                    rel: "noopener"
                                                  }
                                                },
                                                [
                                                  _c("masked-image", {
                                                    attrs: {
                                                      src:
                                                        "/img/icons/twitter-big.svg"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lang.labels.twitter
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.agency.active &&
                                          _vm.agency.url_agency
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-contact webagency",
                                                  attrs: {
                                                    href: _vm.agency.url_agency,
                                                    target: "_blank",
                                                    rel: "noopener"
                                                  }
                                                },
                                                [
                                                  _c("masked-image", {
                                                    attrs: {
                                                      src:
                                                        "/img/icons/site-agency.svg",
                                                      alt:
                                                        _vm.lang.labels.homepage
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lang.labels.homepage
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.agency.active &&
                                          _vm.agency.url_sell
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-contact ml-auto sell",
                                                  attrs: {
                                                    href: _vm.agency.url_sell,
                                                    target: "_blank",
                                                    rel: "noopener"
                                                  }
                                                },
                                                [
                                                  _c("masked-image", {
                                                    attrs: {
                                                      src:
                                                        "/img/icons/evaluation-agency.svg",
                                                      alt: _vm.lang.labels.sell
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.lang.labels.sell
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-network ml-auto details",
                                              attrs: {
                                                href: _vm.agency.url_site,
                                                target: "_blank",
                                                rel: "noopener"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.lang.labels.details
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-network ml-auto calculate-route",
                                              attrs: {
                                                href: _vm.agency.url_site,
                                                target: "_blank",
                                                rel: "noopener"
                                              }
                                            },
                                            [
                                              _c("masked-image", {
                                                attrs: {
                                                  src:
                                                    "/img/icons/route-agency.svg",
                                                  alt: _vm.lang.labels.sell
                                                }
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.lang.labels
                                                      .calculate_route
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ]
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.canShowTeam
            ? _c("div", [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "agency-team" },
                    [
                      _c("h4", { staticClass: "agency-team-title" }, [
                        _c("img", {
                          attrs: { src: "/img/icons/agency-team.svg" }
                        }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.lang.labels.team) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("agency-team-carousel", {
                        attrs: {
                          "per-page": _vm.teamPerPage,
                          team: _vm.agency.team
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }